import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import DialogBody from "../dialog/DialogBody";
import DialogHeader from "../dialog/DialogHeader";
import GlobalButton from "../button";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    // width: "100px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiTableContainer-root .MuiTable-root .MuiTableHead-root": {
    backgroundColor: "#f3f3f3",
  },
  "& .MuiTableCell-root ": {
    padding: "8px 16px",
  },
}));

const renderCard = (data) => {
  const isDiscount = data.discount > 0 ? true : false;
  const productPrice = data.discount > 0 ? data.discount : data.price;

  return (
    <Card>
      <CardActionArea>
        <CardMedia
          component="img"
          height="200px"
          image={data.coverImage}
          alt={data.name}
          sx={{
            "&.MuiCardMedia-media": {
              objectFit: "contain",
            },
          }}
        />
        <CardContent>
          <Typography gutterBottom variant="body1" noWrap>
            {data.name}
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            my={0.5}
          >
            <Typography fontSize="1.125rem">${data.finalPrice}</Typography>
            {isDiscount && (
              <Typography
                fontSize="1rem"
                color="grey"
                sx={{ textDecoration: "line-through" }}
              >
                ${data.price}
              </Typography>
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const PackageProductsDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setDialogData(params);
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth={"lg"}
    >
      <DialogHeader title="productIncluded" />

      <DialogBody>
        <Grid container spacing={2}>
          {dialogData?.data?.map((val, index) => {
            return (
              <Grid item xs={12} md={3} key={index}>
                {renderCard(val)}
              </Grid>
            );
          })}
        </Grid>
      </DialogBody>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"close"}
          handleClickBtn={handleClose}
          styleProps={{
            height: 38,
            width: 100,
            borderRadius: "6px",
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default PackageProductsDialog;
